var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import AntdMessage from 'antd/es/message';
import classnames from 'classnames';
import { CheckFillIcon, CloseFillIcon, CloseIcon, InfoFillIcon, LoadingOIcon, WarningFillIcon } from '../icon';
var MsgType;
(function (MsgType) {
    MsgType["info"] = "info";
    MsgType["success"] = "success";
    MsgType["error"] = "error";
    MsgType["warning"] = "warning";
    MsgType["loading"] = "loading";
})(MsgType || (MsgType = {}));
let idd = 1;
const formatParams = (msgType, contentConfig, duration, onClose) => {
    const MessageIcon = {
        success: CheckFillIcon,
        warning: WarningFillIcon,
        error: CloseFillIcon,
        info: InfoFillIcon,
        loading: LoadingOIcon
    }[msgType];
    const prefixCls = 'ysd-message';
    const classNames = classnames(prefixCls);
    if (typeof contentConfig === 'object') {
        const _a = contentConfig, { icon, content, className, duration: configDuration, onClose: configOnClose, autoClose = true, key = idd++ } = _a, rest = __rest(_a, ["icon", "content", "className", "duration", "onClose", "autoClose", "key"]);
        return Object.assign(Object.assign({}, rest), { key, type: msgType, className: classnames(classNames, className), duration: autoClose ? configDuration : 0, onClose: configOnClose, content: (React.createElement(React.Fragment, null,
                content,
                !autoClose ? (React.createElement(CloseIcon, { className: `${prefixCls}-icon-close`, colorType: 'default', onClick: () => {
                        AntdMessage.destroy(key);
                        configOnClose === null || configOnClose === void 0 ? void 0 : configOnClose();
                    } })) : null)), icon: icon ? icon : MessageIcon && React.createElement(MessageIcon, { spin: msgType === 'loading' }) });
    }
    else {
        const params = {
            type: msgType,
            className: classNames,
            content: contentConfig,
            icon: MessageIcon && React.createElement(MessageIcon, { spin: msgType === 'loading' })
        };
        return typeof duration === 'function'
            ? Object.assign(Object.assign({}, params), { duration: undefined, onClose: duration }) : Object.assign(Object.assign({}, params), { duration,
            onClose });
    }
};
const getMessageInstance = message => {
    const msgInstance = {
        open: config => {
            const { type } = config, rest = __rest(config, ["type"]);
            const params = formatParams(type, rest);
            return message.open(params);
        }
    };
    for (const key in MsgType) {
        msgInstance[MsgType[key]] = (contentConfig, duration, onClose) => {
            const params = formatParams(MsgType[key], contentConfig, duration, onClose);
            return message[MsgType[key]](params);
        };
    }
    return msgInstance;
};
const messageInstance = getMessageInstance(AntdMessage);
const Message = Object.assign(Object.assign(Object.assign({}, AntdMessage), messageInstance), { warn: messageInstance.warning, useMessage: () => {
        const [messageHooksApi, contextHolder] = AntdMessage.useMessage();
        return [getMessageInstance(messageHooksApi), contextHolder];
    } });
export default Message;
